import React, { FunctionComponent } from 'react';
import { SanityArticleCategory, SanityCategoryGroup } from '../../types/common';
import { AdvancedFilter } from './AdvancedFilter';
import { SimpleFilter } from './SimpleFilter';
import './styles.scss';

type FiltersProps = {
  data: {
    isAdvanced?: boolean | null;
    isAdvancedFilterOpen?: boolean;
    onCloseAdvancedFilter?: () => void;
    groups?: SanityCategoryGroup[] | null;
    categories?: SanityArticleCategory[] | null;
    filteredCategories: string[];
    filteredGroups?: string[];
    onFilter: (categoryId: string) => void;
    onFilterGroup?: (groupKey: string) => void;
    onClearFilters: () => void;
  }
}

const Filters: FunctionComponent<FiltersProps> = ({ data }) => {
  if (!data.categories || !data.filteredCategories || !data.onFilter || !data.onClearFilters) {
    return null;
  }

  if (data.isAdvanced && data.groups && data.onFilterGroup && data.filteredGroups) {
    return (
      <AdvancedFilter
        groups={data.groups}
        categories={data.categories}
        filteredCategories={data.filteredCategories}
        filteredGroups={data.filteredGroups}
        onFilter={data.onFilter}
        onFilterGroup={data.onFilterGroup}
        onClearFilters={data.onClearFilters}
        isFilterOpen={data.isAdvancedFilterOpen}
        onCloseFilter={data.onCloseAdvancedFilter}
      />
    );
  }

  return (
    <SimpleFilter
      categories={data.categories}
      filteredCategories={data.filteredCategories}
      onFilter={data.onFilter}
      onClearFilters={data.onClearFilters}
    />
  );
}

export default Filters;
